// extracted by mini-css-extract-plugin
module.exports = {"fullScreenLoader":"FullScreenLoader_fullScreenLoader__6Z3B3","loader":"FullScreenLoader_loader__pbbbf"};